module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "srmcloud-content"
  }, [_c('banner', {
    attrs: {
      "clazz": "srmcloud-banner",
      "url": "srmcloud",
      "hasDivider": ""
    }
  }, [_c('template', {
    slot: "buttons"
  }, [_c('el-button', {
    staticClass: "banner-button",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.goMore('srm-banner-tiyan')
      }
    }
  }, [_vm._v("申请体验")]), _vm._v(" "), _c('el-button', {
    staticClass: "banner-button",
    attrs: {
      "round": ""
    },
    on: {
      "click": this.goConsult
    }
  }, [_vm._v("立即咨询")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "srmcloud-section1"
  }, [_c('div', {
    staticClass: "section1-content"
  }, [_c('img', {
    staticClass: "section1-img",
    attrs: {
      "src": require("../../assets/img/srmCloud/section1@2x.png"),
      "alt": "什么是甄云SaaS云平台"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "section1-misc"
  }, [_c('h1', {
    staticClass: "misc-title"
  }, [_vm._v("一体化数字采购管理平台-甄采云")]), _vm._v(" "), _c('div', {
    staticClass: "misc-divider"
  }), _vm._v(" "), _c('p', {
    staticClass: "misc-content"
  }, [_vm._v("\n          一款自主可控和基于云部署的企业级采购管理平台，一站式满足企业采购申请、供应商管理、询报价、合同、对账等采购全流程管理。无需额外购买硬件、数周时间即可上线，超过1000个功能灵活配置，90%以上客制化需求无须二次开发，充分以用户为中心兼顾行业差异，让企业实现采购数字化不再难。\n        ")]), _vm._v(" "), _c('el-button', {
    staticClass: "consult-button",
    nativeOn: {
      "click": function($event) {
        return _vm.goMore('srm-yunpingtai-yanshi')
      }
    }
  }, [_vm._v("预约演示\n          "), _c('img', {
    attrs: {
      "src": require("../../assets/img/bidding/icon_demo.svg"),
      "alt": "预约演示"
    }
  })])], 1)])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "srmcloud-section3 tc"
  }, [_c('h1', {
    staticClass: "section3-title"
  }, [_vm._v("甄采云功能概括")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "section3-table"
  }, [_c('div', {
    staticClass: "table-content dib tl"
  }, [_c('div', {
    staticClass: "line first dib tc"
  }, [_c('div', {
    staticClass: "cell custom-388 dib",
    style: ({
      'backgroundImage': 'url(' + require('../../assets/img/srmCloud/zhushuju-bg.png') + ')'
    })
  }, [_c('div', {
    staticClass: "container",
    on: {
      "click": function($event) {
        return _vm.goMore('srm-gongneng-zhushuju')
      }
    }
  }, [_c('img', {
    staticClass: "cell-icon",
    attrs: {
      "src": require("../../assets/img/srmCloud/zhushuju_icon.png"),
      "alt": "主数据管理"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "cell-title"
  }, [_vm._v("主数据管理")]), _vm._v(" "), _c('div', {
    staticClass: "cell-divider dib"
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('p', {
    staticClass: "go-detail"
  }, [_vm._v("了解详情 >")])]), _vm._v(" "), _c('div', {
    staticClass: "cell custom-469 dib",
    style: ({
      'backgroundImage': 'url(' + require('../../assets/img/srmCloud/xunyuan-bg.png') + ')'
    })
  }, [_vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "go-detail"
  }, [_vm._v("了解详情 >")])]), _vm._v(" "), _c('div', {
    staticClass: "cell custom-273 dib",
    style: ({
      'backgroundImage': 'url(' + require('../../assets/img/srmCloud/shengchan.png') + ')'
    })
  }, [_c('div', {
    staticClass: "container",
    on: {
      "click": function($event) {
        return _vm.goPurchasecoordination(3400)
      }
    }
  }, [_c('img', {
    staticClass: "cell-icon",
    attrs: {
      "src": require("../../assets/img/srmCloud/shengchan_icon.png"),
      "alt": "生产协同"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "cell-title"
  }, [_vm._v("生产协同")]), _vm._v(" "), _c('div', {
    staticClass: "cell-divider dib"
  }), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('p', {
    staticClass: "go-detail"
  }, [_vm._v("了解详情 >")])])]), _vm._v(" "), _c('div', {
    staticClass: "line second dib tc"
  }, [_c('div', {
    staticClass: "cell custom-281 dib",
    style: ({
      'backgroundImage': 'url(' + require('../../assets/img/srmCloud/gongyingshang.png') + ')'
    })
  }, [_vm._m(5), _vm._v(" "), _c('p', {
    staticClass: "go-detail"
  }, [_vm._v("了解详情 >")])]), _vm._v(" "), _c('div', {
    staticClass: "cell custom-469 dib",
    style: ({
      'backgroundImage': 'url(' + require('../../assets/img/srmCloud/hetong.png') + ')'
    })
  }, [_vm._m(6), _vm._v(" "), _c('p', {
    staticClass: "go-detail"
  }, [_vm._v("了解详情 >")])]), _vm._v(" "), _c('div', {
    staticClass: "cell custom-380 dib",
    style: ({
      'backgroundImage': 'url(' + require('../../assets/img/srmCloud/zhiliang-bg.png') + ')'
    })
  }, [_c('div', {
    staticClass: "container",
    on: {
      "click": function($event) {
        return _vm.goPurchasecoordination(2956)
      }
    }
  }, [_c('img', {
    staticClass: "cell-icon",
    attrs: {
      "src": require("../../assets/img/srmCloud/zhiliang_icon.png"),
      "alt": "质量协同"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "cell-title"
  }, [_vm._v("质量协同")]), _vm._v(" "), _c('div', {
    staticClass: "cell-divider dib"
  }), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('p', {
    staticClass: "go-detail"
  }, [_vm._v("了解详情 >")])])]), _vm._v(" "), _c('div', {
    staticClass: "line third dib tc"
  }, [_c('div', {
    staticClass: "cell custom-469 dib",
    style: ({
      'backgroundImage': 'url(' + require('../../assets/img/srmCloud/xuqiu.png') + ')'
    })
  }, [_c('div', {
    staticClass: "container",
    on: {
      "click": function($event) {
        return _vm.goMore('srm-gongneng-caigouxuqiu')
      }
    }
  }, [_c('img', {
    staticClass: "cell-icon",
    attrs: {
      "src": require("../../assets/img/srmCloud/xuqiu_icon.png"),
      "alt": "采购需求管理"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "cell-title"
  }, [_vm._v("采购需求管理")]), _vm._v(" "), _c('div', {
    staticClass: "cell-divider dib"
  }), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('p', {
    staticClass: "go-detail"
  }, [_vm._v("了解详情 >")])]), _vm._v(" "), _c('div', {
    staticClass: "cell custom-388 dib",
    style: ({
      'backgroundImage': 'url(' + require('../../assets/img/srmCloud/dingdan.png') + ')'
    })
  }, [_c('div', {
    staticClass: "container",
    on: {
      "click": function($event) {
        return _vm.goPurchasecoordination(1376)
      }
    }
  }, [_c('img', {
    staticClass: "cell-icon",
    attrs: {
      "src": require("../../assets/img/srmCloud/dingdan_icon.png"),
      "alt": "采购订单协同"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "cell-title"
  }, [_vm._v("采购订单协同")]), _vm._v(" "), _c('div', {
    staticClass: "cell-divider dib"
  }), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('p', {
    staticClass: "go-detail"
  }, [_vm._v("了解详情 >")])]), _vm._v(" "), _c('div', {
    staticClass: "cell custom-273 dib",
    style: ({
      'backgroundImage': 'url(' + require('../../assets/img/srmCloud/duizhang.png') + ')'
    })
  }, [_c('div', {
    staticClass: "container",
    on: {
      "click": function($event) {
        return _vm.goPurchasecoordination(2470)
      }
    }
  }, [_c('img', {
    staticClass: "cell-icon",
    attrs: {
      "src": require("../../assets/img/srmCloud/duizhang_icon.png"),
      "alt": "对账结算"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "cell-title"
  }, [_vm._v("对账结算")]), _vm._v(" "), _c('div', {
    staticClass: "cell-divider dib"
  }), _vm._v(" "), _vm._m(10)]), _vm._v(" "), _c('p', {
    staticClass: "go-detail"
  }, [_vm._v("了解详情 >")])])])])]), _vm._v(" "), _c('h1', {
    staticClass: "section3-title"
  }, [_vm._v("甄采云.超越采购，推动战略执行")]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "section3-collpase dib",
    on: {
      "mouseleave": function($event) {
        return _vm.chooseTab('first')
      }
    }
  }, [_c('div', {
    staticClass: "section3-main"
  }, [_c('div', {
    staticClass: "section3-choose"
  }, [_c('div', {
    staticClass: "left-list"
  }, [_c('div', {
    staticClass: "choice first",
    class: this.choice === 'first' ? 'is-choosed' : '',
    on: {
      "mouseenter": function($event) {
        return _vm.chooseTab('first')
      }
    }
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "triangle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "choice second",
    class: this.choice === 'second' ? 'is-choosed' : '',
    on: {
      "mouseenter": function($event) {
        return _vm.chooseTab('second')
      }
    }
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "triangle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "choice third",
    class: this.choice === 'third' ? 'is-choosed' : '',
    on: {
      "mouseenter": function($event) {
        return _vm.chooseTab('third')
      }
    }
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "triangle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "choice fourth",
    class: this.choice === 'fourth' ? 'is-choosed' : '',
    on: {
      "mouseenter": function($event) {
        return _vm.chooseTab('fourth')
      }
    }
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "triangle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "choice fifth",
    class: this.choice === 'fifth' ? 'is-choosed' : '',
    on: {
      "mouseenter": function($event) {
        return _vm.chooseTab('fifth')
      }
    }
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "triangle"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.choice === 'first'),
      expression: "choice === 'first'"
    }],
    staticClass: "first-content content-img"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("深度的采购闭环管理 合规性提升45%")]), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('img', {
    staticClass: "image",
    attrs: {
      "src": require("../../assets/img/srmCloud/1-peitu-1.png"),
      "alt": "深度的采购闭环管理"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.choice === 'second'),
      expression: "choice === 'second'"
    }],
    staticClass: "second-content content-img"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("丰富的采购资源 寻源效率整体提升40%")]), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('img', {
    staticClass: "image single",
    attrs: {
      "src": require("../../assets/img/srmCloud/2-peitu-1.png"),
      "alt": "丰富的采购资源"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.choice === 'third'),
      expression: "choice === 'third'"
    }],
    staticClass: "third-content content-img"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("高效作业 释放采购劳动力")]), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('img', {
    staticClass: "image",
    attrs: {
      "src": require("../../assets/img/srmCloud/3-peitu-1.png"),
      "alt": "高效作业释放采购劳动力"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.choice === 'fourth'),
      expression: "choice === 'fourth'"
    }],
    staticClass: "fourth-content content-img"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("通用技术平台 安全稳定")]), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('img', {
    staticClass: "image",
    attrs: {
      "src": require("../../assets/img/srmCloud/4-1.png"),
      "alt": "通用技术平台安全稳定"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.choice === 'fifth'),
      expression: "choice === 'fifth'"
    }],
    staticClass: "fifth-content content-img"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("采购智能分析与预测 助力采购成本优化")]), _vm._v(" "), _vm._m(21), _vm._v(" "), _c('img', {
    staticClass: "image",
    attrs: {
      "src": require("../../assets/img/srmCloud/5-1.png"),
      "alt": "采购智能分析与预测,助力采购成本优化"
    }
  })])])])]), _vm._v(" "), _c('el-button', {
    staticClass: "consult-btn",
    nativeOn: {
      "click": function($event) {
        return _vm.goMore('srm-zhanlue-yanshi')
      }
    }
  }, [_vm._v("预约演示\n        "), _c('img', {
    attrs: {
      "src": require("../../assets/img/bidding/icon_demo.svg"),
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('h1', {
    staticClass: "section3-title"
  }, [_vm._v("典型客户案例")]), _vm._v(" "), _c('div', {
    staticClass: "section3-divider dib"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "section3-systemlist tl dib"
  }, [_c('span', {
    staticClass: "expand-content dib"
  }, _vm._l((_vm.expandItemList), function(item, index) {
    return _c('div', {
      staticClass: "expandItem tc dib",
      class: index === 0 ? 'expand' : '',
      style: ({
        'backgroundImage': item.yiz_img ? 'url(' + _vm.$global.globalPath + item.yiz_img + ')' : ''
      }),
      on: {
        "mouseenter": function($event) {
          return _vm.listExpandOn(index)
        },
        "mouseleave": _vm.listExpandOff,
        "touchstart": function($event) {
          return _vm.listExpandOn(index)
        },
        "touchend": function($event) {
          return _vm.listExpandOn(index)
        }
      }
    }, [_c('div', {
      staticClass: "expandItemMask"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (_vm.$global.globalPath + item.yiz_logo),
        expression: "$global.globalPath + item.yiz_logo"
      }],
      staticClass: "expandItemIcon",
      attrs: {
        "alt": "logo"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "expandItemTextContainer"
    }, [_c('p', {
      staticClass: "expandItemText textContent tl"
    }, [_vm._v(_vm._s(index === 0 ? item.yiz_describe : item.title))]), _vm._v(" "), _c('p', {
      staticClass: "expandItemText textFooter tl"
    }, [_vm._v(_vm._s(item.yiz_seo ? '——' + item.yiz_seo : ''))]), _vm._v(" "), _c('p', {
      staticClass: "expandShowDetail tc",
      on: {
        "click": function($event) {
          return _vm.goClientDetail(item.id, item.status)
        }
      }
    }, [_vm._v("了解案例详情 >\n                ")])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "expandItem static tc dib",
    on: {
      "click": _vm.listMove
    }
  }, [_c('img', {
    staticClass: "expandItemIcon",
    attrs: {
      "src": require("../../assets/img/purchaseManage/arrow@2x.png"),
      "alt": "expandItemIcon"
    }
  })])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "srmcloud-section2"
  }, [_c('div', {
    staticClass: "section2-content"
  }, [_c('h1', {
    staticClass: "section2-title"
  }, [_vm._v("解决的采购痛点")]), _vm._v(" "), _c('div', {
    staticClass: "section2-divider dib"
  }), _vm._v(" "), _c('div', {
    staticClass: "section2-main"
  }, [_c('div', {
    staticClass: "content-box first dib"
  }, [_c('img', {
    staticClass: "box-icon",
    attrs: {
      "src": require("../../assets/img/srmCloud/icon-1@2x.png"),
      "alt": "效率低"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "box-title"
  }, [_vm._v("效率低")]), _vm._v(" "), _c('p', {
    staticClass: "box-content"
  }, [_vm._v("\n            企业与企业之间协同效率低"), _c('br'), _vm._v("\n            企业内部不同部门协同效率低\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "content-box second dib"
  }, [_c('img', {
    staticClass: "box-icon",
    attrs: {
      "src": require("../../assets/img/srmCloud/icon-2@2x.png"),
      "alt": "成本高"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "box-title"
  }, [_vm._v("成本高")]), _vm._v(" "), _c('p', {
    staticClass: "box-content"
  }, [_vm._v("\n            管理成本高"), _c('br'), _vm._v("\n            采购成本高\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "content-box third dib"
  }, [_c('img', {
    staticClass: "box-icon",
    attrs: {
      "src": require("../../assets/img/srmCloud/icon-3@2x.png"),
      "alt": "管控难"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "box-title"
  }, [_vm._v("管控难")]), _vm._v(" "), _c('p', {
    staticClass: "box-content"
  }, [_vm._v("\n            合规性差"), _c('br'), _vm._v("\n            采购不透明\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "content-box fourth dib"
  }, [_c('img', {
    staticClass: "box-icon",
    attrs: {
      "src": require("../../assets/img/srmCloud/icon-4@2x.png"),
      "alt": "信息闭塞"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "box-title"
  }, [_vm._v("信息闭塞")]), _vm._v(" "), _c('p', {
    staticClass: "box-content"
  }, [_vm._v("\n            数据难以共享和分析\n          ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "section3-divider dib"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cell-content tl"
  }, [_c('div', {
    staticClass: "cell-detail"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('p', [_vm._v("物料特性")]), _vm._v(" "), _c('p', [_vm._v("供应商档案")])]), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [_c('p', [_vm._v("物料档案")]), _vm._v(" "), _c('p', [_vm._v("货源与配额")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/purchasemanage",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "cell-icon",
    attrs: {
      "src": require("../../assets/img/srmCloud/xunyuan_icon.png"),
      "alt": "寻源管理"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "cell-title"
  }, [_vm._v("寻源管理")]), _vm._v(" "), _c('div', {
    staticClass: "cell-divider dib"
  }), _vm._v(" "), _c('div', {
    staticClass: "cell-content tl"
  }, [_c('div', {
    staticClass: "cell-detail"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('p', [_vm._v("询报价管理")]), _vm._v(" "), _c('p', [_vm._v("招投标管理")])]), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [_c('p', [_vm._v("竞价拍卖")]), _vm._v(" "), _c('p', [_vm._v("采购目录")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cell-content tl"
  }, [_c('div', {
    staticClass: "cell-detail"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('p', [_vm._v("OME管理")]), _vm._v(" "), _c('p', [_vm._v("第三方收货")])]), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [_c('p', [_vm._v("工厂直发")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/supplier",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "cell-icon",
    attrs: {
      "src": require("../../assets/img/srmCloud/gongyingshang_icon.png"),
      "alt": "供应商管理"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "cell-title"
  }, [_vm._v("供应商管理")]), _vm._v(" "), _c('div', {
    staticClass: "cell-divider dib"
  }), _vm._v(" "), _c('div', {
    staticClass: "cell-content tl"
  }, [_c('div', {
    staticClass: "cell-detail"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('p', [_vm._v("准入评估")]), _vm._v(" "), _c('p', [_vm._v("绩效管理")])]), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [_c('p', [_vm._v("分类/状态")]), _vm._v(" "), _c('p', [_vm._v("整改&淘汰")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/contractmanage",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "cell-icon",
    attrs: {
      "src": require("../../assets/img/srmCloud/hetong_icon.png"),
      "alt": "合同管理"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "cell-title"
  }, [_vm._v("合同管理")]), _vm._v(" "), _c('div', {
    staticClass: "cell-divider dib"
  }), _vm._v(" "), _c('div', {
    staticClass: "cell-content tl"
  }, [_c('div', {
    staticClass: "cell-detail"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('p', [_vm._v("合同类型")]), _vm._v(" "), _c('p', [_vm._v("合同模板")])]), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [_c('p', [_vm._v("合同文本")]), _vm._v(" "), _c('p', [_vm._v("合同履行")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cell-content tl"
  }, [_c('div', {
    staticClass: "cell-detail"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('p', [_vm._v("质量数据")]), _vm._v(" "), _c('p', [_vm._v("质量事件")])]), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [_c('p', [_vm._v("质量费用")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cell-content tl"
  }, [_c('div', {
    staticClass: "cell-detail"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('p', [_vm._v("需求提报")]), _vm._v(" "), _c('p', [_vm._v("汇总及审核")])]), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [_c('p', [_vm._v("发布&确认")]), _vm._v(" "), _c('p', [_vm._v("供应商产能")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cell-content tl"
  }, [_c('div', {
    staticClass: "cell-detail"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('p', [_vm._v("订单生成&审核")]), _vm._v(" "), _c('p', [_vm._v("订单过程监控")]), _vm._v(" "), _c('p', [_vm._v("送货预约审核")])]), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [_c('p', [_vm._v("发布&确认")]), _vm._v(" "), _c('p', [_vm._v("送货安排")]), _vm._v(" "), _c('p', [_vm._v("收发退货")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cell-content tl"
  }, [_c('div', {
    staticClass: "cell-detail"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('p', [_vm._v("扣费附加费")]), _vm._v(" "), _c('p', [_vm._v("对账与审核")])]), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [_c('p', [_vm._v("发票与付款")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "section3-divider dib"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "choice-content"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../assets/img/srmCloud/3-1_ICON.png"),
      "alt": "深度的采购闭环管理"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "text"
  }, [_vm._v("深度的采购闭环管理"), _c('br'), _vm._v("合规性提升45%")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "choice-content"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../assets/img/srmCloud/3-2_ICON.png"),
      "alt": "丰富的采购资源"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "text"
  }, [_vm._v("丰富的采购资源"), _c('br'), _vm._v("寻源效率整体提升40% ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "choice-content"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../assets/img/srmCloud/3-3_ICON.png"),
      "alt": "高效作业"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "text"
  }, [_vm._v("高效作业"), _c('br'), _vm._v("释放采购劳动力")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "choice-content"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../assets/img//srmCloud/3-4_icon.png"),
      "alt": "通用技术平台"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "text"
  }, [_vm._v("通用技术平台"), _c('br'), _vm._v("安全稳定 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "choice-content"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../assets/img/srmCloud/3-5_ICON.png"),
      "alt": "采购智能分析与预测"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "text"
  }, [_vm._v("采购智能分析与预测"), _c('br'), _vm._v("助力采购成本优化")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("供应商准入评审：分品类，多策略的准入管控机制")]), _vm._v(" "), _c('p', [_vm._v("历史价格管理：询比价历史查询，采购价格库管控")]), _vm._v(" "), _c('p', [_vm._v("供应商绩效管理绩效自动计算，绩效结果跟踪")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("电商资源：平台已对接通用物资电商、MRO物资电商供应商系统无缝集成 ")]), _vm._v(" "), _c('p', [_vm._v("云平台撮合：需求发布云平台，触及云平台数万供应商，提升寻源效率 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("业务超期预警：预制业务预警条件，及时提醒异常情况")]), _vm._v(" "), _c('p', [_vm._v("自动对账：预制自动对账规则，减少人工核对")]), _vm._v(" "), _c('p', [_vm._v("发票自动入账：支持与各主流ERP系统集成，接口对接生成应付数据")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("通用数据接口：对主流ERP系统有成熟接口套件，随装随用，数百家客户验证，高效稳定")]), _vm._v(" "), _c('p', [_vm._v("安全机制：专业级平台、数据、系统安全防护")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("报价模型：可针对不同品类进行报价模型设定，建立多维价格信息库")]), _vm._v(" "), _c('p', [_vm._v("大宗商品价格预警：基于大宗商品价格变动， 及时获取价格变动信息并进行价格调整")]), _vm._v(" "), _c('p', [_vm._v("报表定制：为企业量身打造数据模型，助力企业采购决策，费用支出分析，价格分析等")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f9d052d"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/srmcloud.vue
// module id = 489
// module chunks = 12